import React from 'react';
import { ENUM_COOKIE_NAME } from '../enum/API';

export function getCookie(c_name: ENUM_COOKIE_NAME): string {
    var i,
        x,
        y,
        ARRcookies = document.cookie.split(';');
    for (i = 0; i < ARRcookies.length; i++) {
        x = ARRcookies[i].substr(0, ARRcookies[i].indexOf('='));
        y = ARRcookies[i].substr(ARRcookies[i].indexOf('=') + 1);
        x = x.replace(/^\s+|\s+$/g, '');
        if (x === c_name) {
            return unescape(y);
        }
    }
    return '';
}

export function timeFormat(time: number) {
    return `${(time % 3600) / 60 >= 10 ? Math.floor((time % 3600) / 60) : `0${Math.floor((time % 3600) / 60)}`}:${
        time % 60 >= 10 ? Math.floor(time % 60) : `0${Math.floor(time % 60)}`
    }`;
}

export function createRandomString(length: number): string {
    const chars: string = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXTZabcdefghiklmnopqrstuvwxyz';
    let randomstring: string = '';
    for (let i = 0; i < length; i++) {
        const rnum = Math.floor(Math.random() * chars.length);
        randomstring = randomstring + chars.substring(rnum, rnum + 1);
    }
    return randomstring;
}

// FIXME any 포함
export function useInput(defaultValue: string) {
    const [value, setValue] = React.useState(defaultValue);
    const onChange = (e: React.ChangeEvent<any>) => {
        const {
            target: { value },
        } = e;
        setValue(value);
    };
    return { value, onChange, setValue };
}

interface asdf<T> {
    [id: string]: T;
}
